define('fukit/view/common/page.header.view',['require','exports','module','underscore','uikit/uikit','backbone.radio','../../helpers/factory','appkit/util/key.prefixer','../../helpers/route.helper','../../behavior/resolve.route.behavior','./page.resource.error.message.view','../../behavior/resource.errors.behavior','../../templates','uikit/extra/extend.util'],function(require, exports, module) {
  //prettier-ignore
  var _                            = require('underscore'),
      UIKit                        = require('uikit/uikit'),
      Radio                        = require('backbone.radio'),
      Factory                      = require('../../helpers/factory'),
      KeyPrefixer                  = require('appkit/util/key.prefixer'),
      RouteHelper                  = require('../../helpers/route.helper'),
      ResolveRouteBehavior         = require('../../behavior/resolve.route.behavior'),
      PageResourceErrorMessageView = require('./page.resource.error.message.view'),
      ResourceErrorsBehavior       = require('../../behavior/resource.errors.behavior'),
      Templates                    = require('../../templates'),
      ExtendUtil                   = require('uikit/extra/extend.util');

  var ActionsFromCollectionView = UIKit.ComponentsContainerView.extend({
    childView: UIKit.ComponentsContainerView.extend({
      attributes: {
        style: 'display: inline;',
      },

      components: [
        {
          type: UIKit.Button,
          name: 'button',
          behaviors: {
            ResolveRouteBehavior: {
              behaviorClass: ResolveRouteBehavior,
            },
          },
        },
      ],
    }),
  });

  var PageHeaderView = UIKit.ItemView.extend({
    className: 'page header',

    template: Templates.FuKit['page.header'],

    options: {
      actions: null,
      breadcrumbs: null,
      headerText: '',
      actionViewForUnsavedChanges: '',
      actionViewForCreate: '',
      fixed: '',
    },

    internalViewOptions: {
      headerView: Factory.extendOptionValueWithDefaults('header', function() {
        return {
          type: UIKit.Header,
          text: this.getOption('headerText'),
          ariaLevel: '1',
          behaviors: this.getOption('headerTextBehaviors'),
        };
      }),
      breadcrumbView: Factory.extendOptionValueWithDefaults('breadcrumb', function() {
        return {
          type: UIKit.Breadcrumb.extend({
            attributes: { style: 'margin-top: 0;' },
          }),
          childViewOptions: {
            behaviors: {
              ResolveRouteBehavior: {
                behaviorClass: ResolveRouteBehavior,
              },
            },
          },
          collection: this.getOption('breadcrumbsCollection'),
          components: this.getOption('breadcrumbs'),
        };
      }),
      errorMessageView: function() {
        return {
          type: UIKit.Message,
          behaviors: {
            ResourceErrorsBehavior: _.extend({}, this.getOption('resourceErrorsOptions'), {
              behaviorClass: ResourceErrorsBehavior,
              useFieldValidationMessages: false,
              clearPreviousErrorMessages: true,
              clearErrorMessagesOnSync: true,
            }),
          },
        };
      },
      //individually defined static actions, i.e., the "classic" actionsView
      actionsView: {
        type: UIKit.Container,
      },
      //actions generated from a collection of models passed in
      actionsFromCollectionView: Factory.extendOptionValueWithDefaults('actionsFromCollection', {
        type: ActionsFromCollectionView,
      }),
      notificationView: Factory.extendOptionValueWithDefaults('notifications', function() {
        return {
          type: UIKit.InstantNotifications,
          collection: this.getOption('collection'),
        };
      }),
    },

    onInjectedActionsView: function() {
      this.createActionsViewComponents();
    },

    createActionsViewComponents: function() {
      //prettier-ignore
      var componentDefinitions = this.getOption('actions'),
        component = null;

      this.actionViews = {};
      this.actionsView.empty();

      if (!_.isArray(componentDefinitions)) {
        return;
      }

      _.each(
        componentDefinitions,
        function(component) {
          component = this.createActionsViewComponent(component);

          if (component) {
            this.actionsView.add(component);
          }
          if (component && component.getOption('name')) {
            this.actionsView[component.getOption('name')] = component;
          }
        },
        this
      );
    },

    createActionsViewComponent: function(componentDef) {
      //prettier-ignore
      var self      = this,
          state     = Radio.channel('AppKit.controllerService').request('state'),
          component = null,
          typeClass = null;

      if (componentDef && !(componentDef instanceof Backbone.View)) {
        componentDef = _.extend({ type: UIKit.Button, model: this.model }, componentDef);

        componentDef.behaviors = ExtendUtil.extendBehaviors(
          {
            ResolveRouteBehavior: {
              behaviorClass: ResolveRouteBehavior,
            },
          },
          componentDef.behaviors
        );

        typeClass = this.getComponentByType(componentDef.type);
        component = this.buildComponent(componentDef);
      } else if (componentDef instanceof Backbone.View) {
        component = componentDef;
      }

      if (component && component.getOption && component.getOption('name')) {
        this.proxyEventsFrom(component, { withPrefix: component.getOption('name') });
      }

      return component;
    },

    onChangeActions: function() {
      this.createActionsViewComponents();
    },

    getActionView: function(name) {
      return this.actionViews[name];
    },

    updateAttributes: function() {
      this.addClass('fixed', this.getBoolOption('fixed'));
    },
  });

  module.exports = PageHeaderView;
});

